import { PersonalizationClient } from '@atc/personalization-client';
import { Duck } from '@atc/modular-redux';

// Selectors
import selectors from './userDuckSelectors';
import reducer from './userDuckReducer';
import creators from './userDuckCreators/index.js';
import { getClosedModalState, getDefaultEmailRegistrationState } from './userDuckUtils';

// export personalization only for testing
// eslint-disable-next-line import/no-mutable-exports
export let personalization;
export default function userDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'user',
    storePath,
    inventoryDuck,
    savedInventoryDuck,
    initialState = {},
    env = 'qa',
    personalizationClient,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  personalization = personalizationClient || new PersonalizationClient({
    env
  });
  return new Duck({
    ...rest,
    namespace,
    store,
    storePath,
    initialState: {
      showUserState: false,
      isUserEditProfile: false,
      location: {
        city: undefined,
        state: undefined,
        zip: undefined
      },
      profile: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        thumbnailUrl: null
      },
      bookmarks: {
        searchIds: [],
        // list of saved search ids [Number]
        emailAlerts: [],
        // list of email alerts ids [Number]
        search: {},
        // search params: {title: string}
        inventoryBookmarks: {},
        searchBookmarks: {},
        // saved search object
        subscribe: {}
      },
      updateSavedInventory: {
        listing: null,
        bookmark: {
          id: null,
          isSaved: null,
          isExisting: null,
          title: null
        },
        phone: null,
        context: 'update',
        messages: null
      },
      updateSavedSearch: {
        bookmark: {
          id: null,
          title: null,
          savedDate: null,
          searchString: null,
          // ?zip=12345&startYear=1981&...
          searchParams: null // ['makeCodeList', ...]
        },
        phone: null,
        message: null
      },
      hasChatPreviouslyVdpListings: [],
      recommendedInventory: [],
      // [{}]

      errorMessages: null,
      // [ { value: string }, ...]
      // TODO: Do we still need this?
      warningMessages: '',
      // [ { value: string }, ...]

      ...getClosedModalState(),
      ...getDefaultEmailRegistrationState(),
      globalAlert: null,
      // { key: expiredListings, conversionFailure }
      cancelAlerts: false,
      showEmailSubscribeInline: false,
      showBestDeals: true,
      psxNotificationsCount: '0',
      myCarsCount: 0,
      showToast: false,
      ...initialState
    },
    consts: {},
    types: ['ADD_EMAIL_ALERTS_ITEM', 'ADD_SAVED_SEARCH_ITEM', 'CLEAR_GLOBAL_ALERT', 'CLEAR_UI', 'CLEAR_LOCATION', 'HIDE_UPDATE_SAVED_SEARCH', 'HIDE_QUICK_SAVE_LIST', 'HIDE_EMAIL_SUBSCRIBE_MODAL', 'CLEAR_PROFILE', 'REMOVE_EMAIL_ALERTS_ITEM', 'REMOVE_SAVED_SEARCH_ITEM', 'SHOW_EMAIL_SUBSCRIBE_INLINE', 'SET_EMAIL_ALERTS_ITEMS', 'SET_GLOBAL_ALERT', 'SET_INVENTORY_BOOKMARKS', 'SET_LEAD_PROFILE', 'SET_LOCATION', 'SET_PROFILE', 'SET_RECENT_INVENTORY', 'SET_SAVED_SEARCH_ITEM', 'SET_SAVED_SEARCH_IDS', 'SET_SEARCH_BOOKMARKS', 'SET_SUBSCRIBE_SEARCH_ITEM', 'SET_UPDATE_SAVED_SEARCH_STATE', 'SET_RECOMMENDED_INVENTORY', 'SET_QUICK_SAVE_NOTIFICATION_COUNT', 'SET_MAX_QUICK_SAVES_LIMIT', 'UPDATE_SAVED_INVENTORY', 'SHOW_USER_STATE', 'SHOW_QUICK_SAVE_LIST', 'SHOW_UPDATE_SAVED_SEARCH',
    // Email subscribe save - 'Gigya Light'
    'SHOW_EMAIL_SUBSCRIBE_SUCCESS', 'SHOW_EMAIL_SUBSCRIBE_FAILURE', 'SHOW_LIGHT_REGISTRATION_SERVER_ERROR',
    // Best deals subscribe
    'SHOW_BEST_DEALS', 'SHOW_BEST_DEALS_SUBSCRIBE_SUCCESS', 'SHOW_BEST_DEALS_REGISTRATION_SERVER_ERROR',
    // Show/Hide Alerts modal
    'CACHED_TEXT_ALERTS', 'SET_ALERTS_MODAL', 'SET_ALERTS_ERROR',
    // Cancel Account
    'SET_CANCEL_ACCOUNT_CONFIRMATION', 'SHOW_CANCEL_ACCOUNT_SUCCESS',
    // show Cancel Account modal
    'SET_CANCEL_ACCOUNT_MODAL',
    // show New User Modal
    'SHOW_NEW_USER_MODAL', 'SET_PSX_NOTIFICATIONS_COUNT', 'SET_CARS_I_OWN_COUNT', 'UPDATE_HAS_CHAT_PREVIOUSLY_VDP_LISTINGS', 'SET_USER_EDIT_PROFILE', 'SET_SHOW_TOAST'],
    creators: duck => creators(duck, personalization, inventoryDuck, savedInventoryDuck),
    reducer,
    selectors: selectors()
  });
}